import { StoreHistory } from "../../constants";
import { useGetDocument } from "./useGetDocument";

export function useStoreHistory() {
  const [fetchedHistory] = useGetDocument<StoreHistory>("store", "history");
  return fetchedHistory;
}
